import { render, staticRenderFns } from "./cardmap.vue?vue&type=template&id=f0cf1bf4&scoped=true&"
import script from "./cardmap.vue?vue&type=script&lang=js&"
export * from "./cardmap.vue?vue&type=script&lang=js&"
import style0 from "./cardmap.vue?vue&type=style&index=0&id=f0cf1bf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cf1bf4",
  null
  
)

export default component.exports